var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntermediate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 8.7998H6V11.1998H14V8.7998Z",
    fill: "#272A34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 15.5996C15.2 16.0416 14.842 16.3996 14.4 16.3996H13.6C13.158 16.3996 12.8 16.0416 12.8 15.5996V4.39961C12.8 3.95761 13.158 3.59961 13.6 3.59961H14.4C14.842 3.59961 15.2 3.95761 15.2 4.39961V15.5996Z",
    fill: "#272A34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.2002H17.2C17.642 5.2002 18 5.5582 18 6.0002V14.0002C18 14.4422 17.642 14.8002 17.2 14.8002H16V5.2002Z",
    fill: "#272A34"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8 11.1998H19.6C19.8208 11.1998 20 11.0206 20 10.7998C20 10.579 20 9.4206 20 9.1998C20 8.979 19.8208 8.7998 19.6 8.7998H18.8V11.1998Z",
    fill: "#272A34"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79999 4.39961C4.79999 3.95761 5.15799 3.59961 5.59999 3.59961H6.39999C6.84199 3.59961 7.19999 3.95761 7.19999 4.39961V15.5996C7.19999 16.0416 6.84199 16.3996 6.39999 16.3996H5.59999C5.15799 16.3996 4.79999 16.0416 4.79999 15.5996V4.39961Z",
    fill: "#272A34"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14.8002H2.8C2.358 14.8002 2 14.4422 2 14.0002V6.0002C2 5.5582 2.358 5.2002 2.8 5.2002H4V14.8002Z",
    fill: "#272A34"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.2 8.7998H0.4C0.1792 8.7998 0 8.979 0 9.1998C0 9.4206 0 10.579 0 10.7998C0 11.0206 0.1792 11.1998 0.4 11.1998H1.2V8.7998Z",
    fill: "#272A34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntermediate);
export default __webpack_public_path__ + "static/media/Intermediate.1d147164f81559c0a36d82f973aa7e5f.svg";
export { ForwardRef as ReactComponent };